module.exports = __webpack_public_path__ + "static/media/education-object-4-1-0.8bc7c49f.png";